
export class HomePage { 
    objectid: number;
    id: string;
    title: string;
    titoloDescrizione:string;
    titoloBody:string;
    titoloFooter:string;
    description: string;
    accedi:String=new String();
    logo: Array<any> = new Array<any>();
    links: any;
    sezione1: any;
    sezione2: any;
    sezione3: any;
    bottoni:[];
    date_create: string;
    image:string;
   

}
